// Basis-URL des Admin-Backends für die ÖFFENTLICHEN, unauthentifizierten
// Oberflächen: Buchungsstrecke, Anamnesebogen, Termin-Self-Service und
// Recall-Abmeldung.
//
// Warum absolut und nicht relativ wie in apiService.ts: Diese Seiten laufen auf
// der Praxis-Website (seadent.es, All-Inkl, kein Node), das Backend aber auf
// admin.seadent.es (Hetzner). Der Aufruf ist also cross-origin — die erlaubten
// Herkünfte stehen serverseitig in CORS_ORIGINS.
//
// REACT_APP_API_URL überschreibt beides. Das ist der Umschaltpunkt für weitere
// Installationen: Der Demo-Build setzt die Variable auf die Demo-Domain, sodass
// dasselbe Bundle gegen ein anderes Backend läuft. Ohne gesetzte Variable
// verhalten sich alle Aufrufer exakt wie zuvor.
export const PUBLIC_API_BASE_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production'
    ? 'https://admin.seadent.es/api'
    : 'http://localhost:5000/api');
